import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'cigna-video-dialog-loader',
  templateUrl: './video-dialog-loader.component.html',
  styleUrls: ['./video-dialog-loader.component.scss'],
})
export class VideoDialogLoaderComponent implements OnInit {
  spinnerHtml = '<div class="cg-spinner"></div>';
  titleText = '';

  @ViewChild('vidDialog', { static: false }) vidDialog: TemplateRef<any>;

  constructor(private http: HttpClient, public dialog: MatDialog) {}

  openVideoModal = (event: MouseEvent) => {
    const currentTarget = event.currentTarget as HTMLAnchorElement;
    if (currentTarget) {
      event.preventDefault();
      const href = currentTarget.href;
      let linkText = currentTarget.innerText || '';
      if (
        linkText.trim() === '' &&
        currentTarget.nextElementSibling &&
        currentTarget.nextElementSibling.children[0]
      ) {
        linkText =
          (currentTarget.nextElementSibling.children[0] as HTMLAnchorElement)
            .innerText || '';
      }

      if (href) {
        this.titleText = linkText;

        this.dialog.open(this.vidDialog, {
          autoFocus: false,
          width: '750px',
          height: '480px',
        });

        const bodyElement = document.getElementById('dialog-body-content');
        if (bodyElement !== null) {
          bodyElement.innerHTML = this.spinnerHtml;
        }

        this.loadHtmlIntoDialog(href).subscribe(
          (res: Element) => {
            if (bodyElement !== null) {
              bodyElement.innerHTML = '';
              bodyElement.appendChild(res);
            }
          },
          (error) => {},
        );
      }
    }
  };

  ngOnInit() {
    const videos = document.querySelectorAll('a.launch-lightbox');

    videos.forEach((t) => {
      t.addEventListener('click', this.openVideoModal);
    });

    if (videos.length > 0) {
      // load limelight js premptively
      this.preloadLimelightJs();
    }
  }

  /* istanbul ignore next */
  preloadLimelightJs() {
    const tag = document.createElement('script');
    tag.src = `https://video.limelight.com/player/limelightjs-player.js?orgId=6540f51f4b444780ba7c63c5e866d66a`;
    tag.defer = true;
    const s = document.getElementsByTagName('script')[0];

    if (s && s.parentNode) {
      s.parentNode.insertBefore(tag, s);
    }
  }

  loadHtmlIntoDialog(href: string) {
    return this.http
      .get(href, { responseType: 'text' })
      .pipe(map(this.extractVideoHtml));
  }

  /* istanbul ignore next */
  extractVideoHtml(html: string): Element {
    const fragment = document.createRange().createContextualFragment(html);
    const vidContainer = fragment.querySelectorAll(
      'div[style="max-width: 720px"]',
    );
    const lastVid = vidContainer[vidContainer.length - 1];

    const duplicateLimelight = lastVid.querySelectorAll('script')[0];
    duplicateLimelight.remove();

    return lastVid;
  }

  closeDialog() {
    this.dialog.closeAll();
  }
}
